import { useEffect } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Modal, Typography } from '@vivaahealth/design-system';

import styles from './add-card-modal.module.css';

import { CaptureType } from '../../types';
import { Side } from '../../../../../utils/enum';

import Camera from '../../../../../components/Camera';
import { styled } from 'styled-components';

interface AddCardModalProps extends WithTranslation {
  currentSide: Side;
  onClose: () => unknown;
  onCapture: (blob: Blob, type: CaptureType) => void;
}

const StyledModal = styled(Modal)`
  & .MuiPaper-root {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    top: 64px;
  }
`;

const AddCardModal = ({
  currentSide,
  onCapture,
  onClose,
  t,
}: AddCardModalProps) => {
  const captureText = t('capture');
  let description, title: string;
  if (currentSide === Side.Front) {
    description = t('frontCaptureDescription');
    title = t('frontCaptureTitle');
  } else {
    description = t('backCaptureDescription');
    title = t('backCaptureTitle');
  }

  useEffect(() => {
    const formContainer = document.getElementById('root');
    if (!formContainer) {
      return;
    }

    const overflowHiddenStyle = styles['overflow-hidden'];
    formContainer.classList.add(overflowHiddenStyle);

    return () => {
      formContainer.classList.remove(overflowHiddenStyle);
    };
  }, []);

  return (
    <StyledModal open={true} onClose={onClose} title={title} size="large">
      <Camera
        onCapture={(blob) => {
          onCapture(blob, 'camera');
          onClose();
        }}
        onGoBack={onClose}
        captureText={captureText}
      >
        <Typography variant="paragraph-large">{description}</Typography>
      </Camera>
    </StyledModal>
  );
};

export default withTranslation('uploadCard')(AddCardModal);
